import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      { 
        path: "*", 
        beforeEnter(to, from, next) {
            if(!to.fullPath.endsWith(".html") || to.fullPath.endsWith("app.html")|| to.fullPath.endsWith("index.html"))
                return next("/")
        }
    },
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        title: 'Beveiligingsbedrijf',
        canonical: 'https://rijnlandbeveiliging.nl'
      }
    },
    {
      path: '/beveiliging',
      name: 'security',
      component: () => import(/* webpackChunkName: "beveiliging" */ './views/Security.vue'),
      meta: {
        title: 'Beveiligingsdiensten',
        canonical: 'https://rijnlandbeveiliging.nl/beveiliging'
      },
      children: [
        {
          path: 'objectbeveiliging',
          name: 'objectbeveiliging',
          component: () => import(/* webpackChunkName: "objectbeveiliging" */ './views/security/ObjectBeveiliging.vue'),
          meta: {
            title: 'Objectbeveiliging | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/objectbeveiliging',
            description: 'Bij objectbeveiliging is er sprake van beveiliging binnen en rondom een bepaald object, zoals bijvoorbeeld een bedrijfspand.'
          },
        },
        {
          path: 'alarm-opvolging',
          name: 'alarm-opvolging',
          component: () => import(/* webpackChunkName: "alarm-opvolging" */ './views/security/AlarmOpvolging.vue'),
          meta: {
            title: 'Alarm Opvolging | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/alarm-opvolging',
            description: 'Bij het verlaten van uw pand of woning, dient u het alarmsysteem in te schakelen. Na de inschakeling ervan wordt uw pand/woning beschermd tegen indringers.'
          },
        },
        {
          path: 'evenementenbeveiliging',
          name: 'evenementenbeveiliging',
          component: () => import(/* webpackChunkName: "evenementenbeveiliging" */ './views/security/EvenementenBeveiliging.vue'),
          meta: {
            title: 'Evenementenbeveiliging | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/evenementenbeveiliging',
            description: 'Een gedegen beveiligingsplan in combinatie met onze beveiligers zorgt er voor dat uw evenement soepel en zonder incidenten verloopt.'
          },
        },
        {
          path: 'mobiele-surveillance',
          name: 'mobiele-surveillance',
          component: () => import(/* webpackChunkName: "mobiele-surveillance" */ './views/security/MobieleSurveillance.vue'),
          meta: {
            title: 'Mobiele Surveillance | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/mobiele-surveillance',
          },
        },
        {
          path: 'monitoring',
          name: 'monitoring',
          component: () => import(/* webpackChunkName: "monitoring" */ './views/security/Monitoring.vue'),
          meta: {
            title: 'Monitoring | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/monitoring'
          },
        },
        {
          path: 'bouw-beveiliging',
          name: 'bouw-beveiliging',
          component: () => import(/* webpackChunkName: "bouw-beveiliging" */ './views/security/BouwBeveiliging.vue'),
          meta: {
            title: 'Bouwbeveiliging | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/bouw-beveiliging'
          },
        },
        {
          path: 'zorg-beveiliging',
          name: 'zorg-beveiliging',
          component: () => import(/* webpackChunkName: "zorg-beveiliging" */ './views/security/ZorgBeveiliging.vue'),
          meta: {
            title: 'Zorgbeveiliging | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/zorg-beveiliging',
            description: 'Een zorgbeveiliger is niet alleen een extra paar ogen en een stevige persoonlijkheid, maar biedt ook een luisterend oor, straalt rust uit en heeft gevoel voor de zorg.'
          },
        },
        {
          path: 'hotel-beveiliging',
          name: 'hotel-beveiliging',
          component: () => import(/* webpackChunkName: "hotel-beveiliging" */ './views/security/HotelBeveiliging.vue'),
          meta: {
            title: 'Hotelbeveiliging | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/hotel-beveiliging',
            description: 'Als hotelier sta je voor gastvrijheid en comfort. De hotelgasten willen zich altijd thuis voelen en een veilig gevoel hebben in jouw hotel. '
          },
        },
        {
          path: 'winkel-surveillance',
          name: 'winkel-surveillance',
          component: () => import(/* webpackChunkName: "winkel-surveillance" */ './views/security/WinkelSurveillance.vue'),
          meta: {
            title: 'Winkelsurveillance | Beveiliging',
            canonical: 'https://rijnlandbeveiliging.nl/beveiliging/winkel-surveillance',
            description: 'Winkeldiefstal is helaas een veelvoorkomend feit. Dit kan voor u als ondernemer een behoorlijke derving van de omzet betekenen.'
          },
        },
      ]
    },
    {
      path: '/werkenindebeveiliging',
      name: 'work',
      component: () => import(/* webpackChunkName: "work" */ './views/Work.vue'),
      meta: {
        title: 'Werken Bij Ons | Vacatures',
        canonical: 'https://rijnlandbeveiliging.nl/werkenindebeveiliging',
        description: 'Geregeld zijn wij opzoek naar nieuwe medewerkers voor o.a. objectbeveiligers, evenementenbeveiligers, winkelsurveillanten, etc.'
      },
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import(/* webpackChunkName: "partners" */ './views/Partners.vue'),
      meta: {
        title: 'partners',
        canonical: 'https://rijnlandbeveiliging.nl/partners',
        description: 'Onze veiligheidspartners. Veiligheidsteam.nl en Azurity Beveiliging.'
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
      meta: {
        title: 'Contact',
        canonical: 'https://rijnlandbeveiliging.nl/contact',
        description: 'Een object of evenement beveiligen of een ander veiligheids vraagstuk? Neem vrijblijvend contact met ons op voor de mogelijkheden.'
      },
    },
    {
      path: '/gemeente/:city',
      name: 'city',
      component: () => import(/* webpackChunkName: "city" */ './views/City.vue'),
      meta: {
        canonical: 'https://rijnlandbeveiliging.nl/gemeente/'
      },
      beforeEnter: (to, from, next) => {
          to.meta.title = to.params.city;
          to.meta.canonical = 'https://rijnlandbeveiliging.nl/gemeente/' + to.params.city;
          to.meta.description = 'Rijnland Beveiliging verzorgd in verschillende beveiligingsdiensten in ' + to.params.city + '. Denk hierbij aan winkelsurveillanten, horecaportiers, evenementenbeveiligers, EHBO-ers en het beveiligen van objecten.';
          to.meta.keywords = to.params.city + ', Beveiliging, Beveiliger, Security, Beveiliginsbedrijf, Objectbeveiliging, Winkelsurveillance, Evenementenbeveiliging, Receptiediensten, Brandwachten, Verkeersregelaars, EHBO'; 
          return next();
      },
    }
  ]
})
